import { render, staticRenderFns } from "./QuotationsPreview.vue?vue&type=template&id=321d861a&scoped=true&"
import script from "./QuotationsPreview.vue?vue&type=script&lang=js&"
export * from "./QuotationsPreview.vue?vue&type=script&lang=js&"
import style0 from "./QuotationsPreview.vue?vue&type=style&index=0&id=321d861a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321d861a",
  null
  
)

export default component.exports